<mat-toolbar class="subtitulo">Documento Atividade</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>

                <mat-icon>search</mat-icon>
                <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                    <mat-label>Selecione uma atividade</mat-label>
                    <mat-select [(ngModel)]="atividade" name="atividade" required>
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of listaAtividade" [value]="d" >
                            {{d.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>


            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()" [disabled]="formConsultar.invalid">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">


            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef> Descrição </th>
                <td mat-cell *matCellDef="let element" style="width: 45%"> {{element.descricao}} </td>
            </ng-container>

            <ng-container matColumnDef="atividade">
                <th mat-header-cell *matHeaderCellDef> Atividade </th>
                <td mat-cell *matCellDef="let element"  style="width: 40%"> {{element.atividade.descricao}} </td>
            </ng-container>


            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element" style="width: 15%">
                    <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar documento atividade" mat-fab color="primary"
                    [routerLink]="['/documentoatividade/cadastrar']" routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>

